var SecuritySettingAdapter = /** @class */ (function () {
    function SecuritySettingAdapter(data, defaultIsRecordOperation) {
        this._useSecurity = data.useSecurity ? data.useSecurity : false;
        this._recordOperation = {
            isRecordOperation: data.isRecordOperation === undefined ? defaultIsRecordOperation : data.isRecordOperation,
            operationDescription: data.operationDescription ? data.operationDescription : ''
        };
        this._enablePassword = data.enablePassword ? data.enablePassword : false;
    }
    Object.defineProperty(SecuritySettingAdapter.prototype, "useSecurity", {
        get: function () {
            return this._useSecurity;
        },
        set: function (v) {
            this._useSecurity = v;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(SecuritySettingAdapter.prototype, "recordOperation", {
        get: function () {
            return this._recordOperation;
        },
        set: function (v) {
            this._recordOperation = v;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(SecuritySettingAdapter.prototype, "enablePassword", {
        get: function () {
            return this._enablePassword;
        },
        set: function (v) {
            this._enablePassword = v;
        },
        enumerable: true,
        configurable: true
    });
    return SecuritySettingAdapter;
}());
export { SecuritySettingAdapter };
